import React from 'react';

import { SpecialFilterList } from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { getStockFilterParams } from '@/store/reducers/cars-stock';
import { getSpecialFilter } from '@/modules/CarsStock/components/common.helpers';

function SpecialFilter() {
  const stockFilterParams = useTypedSelector(getStockFilterParams);

  if (!stockFilterParams?.flags || stockFilterParams.flags.length === 0) {
    return null;
  }

  return (
    <SpecialFilterList>
      {stockFilterParams?.flags.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {getSpecialFilter(item.id, true)}
          </React.Fragment>
        );
      })}
    </SpecialFilterList>
  );
}

export default SpecialFilter;
